import React, { useState, useContext } from 'react';

import UserContext from '@context/UserContext'
import InputField from '@components/common/InputField';

const Form = () => {
    const [email, setEmail] = useState("")
    const [error, setError] = useState("")
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [success, setSuccess] = useState(false)

    const { resetPassword } = useContext(UserContext)

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError("")

        const response = await resetPassword(email)
        

        if (response?.errors?.length > 0) {
            setError(response?.errors?.[0]?.message);
        } else {
            if (response?.data?.customerRecover?.userErrors?.length > 0) {
                setError("Sorry, we couldn’t find an account with that email.");
            } else {
                setEmail("")
                setSuccess(true)
            }
        }

        setIsSubmitting(false);
    }

    const validateForm = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return email.trim() === "" || !emailRegex.test(email);
    }

	return (
        <React.Fragment>
            <form onSubmit={handleSubmit} className="space-y-4">
                {
                    success ?
                        <div className="flex items-center p-4 mb-4 text-sm text-green-800 border border-green-300 rounded-lg bg-green-50 dark:text-green-400 dark:border-green-800" role="alert">
                            <svg className="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                            </svg>
                            <span className="sr-only">Info</span>
                            <div>
                                <span className="font-medium">A reset email has been sent. Please check your inbox.</span> 
                            </div>
                        </div> : null
                }
                <div className={`space-y-3`}>
                    <InputField
                        id="userEmail"
                        label="Email Address"
                        placeholder=""
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        aria-label={"enter email"}
                        labelOnTop
                    />
                </div>

                <button
                    type="submit"
                    className="w-full btn-primary mt-10"
                    disabled={validateForm() || isSubmitting}
                    aria-label="Send Reset Link"
                >Send Reset Link</button>

                {
                    error != "" ?
                        <div className="flex items-center p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50  dark:text-red-400 dark:border-red-800" role="alert">
                            <svg className="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                            </svg>
                            <span className="sr-only">Info</span>
                            <div>
                                <span className="font-medium">{error}</span> 
                            </div>
                        </div> : null
                }
            </form>
        </React.Fragment>
    )
}

export default Form